"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomProductTextValue = exports.getProductAttributeValue = exports.getFormattedStringValue = exports.getTextFitProps = exports.getTextValue = exports.getCustomValueString = exports.convertOfferFeedPrice = exports.convertRetailProductPrice = exports.convertCentsToEuroString = exports.getDecimalsString = exports.getEurosString = exports.convertCentsToPrice = exports.isValue = void 0;
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var ramda_1 = require("ramda");
var isValue = function (value) { return (value ? value.length > 0 : false); };
exports.isValue = isValue;
var convertCentsToPrice = function (cents) { return cents / 100; };
exports.convertCentsToPrice = convertCentsToPrice;
var getEurosString = function (cents) {
    if (typeof cents == 'number' || typeof cents == 'string') {
        return "".concat(Math.trunc(convertCentsToPrice(typeof cents == 'number' ? cents : parseFloat(cents))));
    }
};
exports.getEurosString = getEurosString;
var getDecimalsString = function (cents) {
    if (typeof cents == 'number' || typeof cents == 'string') {
        var price = convertCentsToPrice(typeof cents == 'number' ? cents : parseFloat(cents)).toString();
        var decimalsString = price.split('.')[1];
        if (!decimalsString) {
            return '00';
        }
        return decimalsString.length === 1 ? "".concat(decimalsString, "0") : decimalsString;
    }
};
exports.getDecimalsString = getDecimalsString;
/** Convert cents to euros, with or without € suffix */
var convertCentsToEuroString = function (cents, noSuffix) {
    var euros = getEurosString(cents);
    var decimals = getDecimalsString(cents);
    var priceString = "".concat(euros, ",").concat(decimals);
    return noSuffix ? "".concat(priceString) : "".concat(priceString, " \u20AC");
};
exports.convertCentsToEuroString = convertCentsToEuroString;
var convertRetailProductPrice = function (cents) { return ({
    integers: getEurosString(cents),
    decimals: getDecimalsString(cents)
}); };
exports.convertRetailProductPrice = convertRetailProductPrice;
/**
 * Convert price string format "1.00 EUR" to integers and decimals
 */
var convertOfferFeedPrice = function (price) {
    var priceCents = parseFloat(price) * 100;
    return isNaN(priceCents)
        ? {
            integers: '0',
            decimals: '00'
        }
        : {
            integers: getEurosString(priceCents),
            decimals: getDecimalsString(priceCents)
        };
};
exports.convertOfferFeedPrice = convertOfferFeedPrice;
/**
 * Get custom value from product or additionalProperties from special customValue syntax
 * @param product
 * @param customValue e.g '%discountBatchSize% %unit%'
 */
var getCustomValueString = function (product, customValue) {
    return customValue.replace(/%([^%]+)%/g, function (match, propertyPath) {
        var value = (0, ramda_1.path)([propertyPath], product);
        if (value) {
            var isPrice = propertyPath === 'price' || propertyPath === 'discountPrice';
            return isPrice ? convertCentsToEuroString(value, true) : value;
        }
        return '';
    });
};
exports.getCustomValueString = getCustomValueString;
/**
 * Get text value from product based on the given attributeName. Always prioritise customValue.
 */
var getTextValue = function (product, attributeName, customValue, formatOptions) {
    var _a;
    if (customValue) {
        return getCustomValueString(product, customValue);
    }
    else if (attributeName === 'price' && !((_a = formatOptions === null || formatOptions === void 0 ? void 0 : formatOptions.currency) === null || _a === void 0 ? void 0 : _a.output)) {
        // by default parse price attribute if format options for currency are not given
        var priceValue = product.discountPrice || product.price;
        return priceValue ? convertCentsToEuroString(priceValue) : undefined;
    }
    var productValue = (0, ramda_1.path)([attributeName], product);
    if (typeof productValue == 'number' || typeof productValue == 'string') {
        return productValue;
    }
    return '';
};
exports.getTextValue = getTextValue;
var getProductCustomValueString = function (product, customValue) {
    return customValue.replace(/%([^%]+)%/g, function (match, propertyPath) { return (0, ramda_1.path)(propertyPath.split('.'), product) || ''; });
};
/**
 * Custom products can have nested object structure
 * and there is no conversion for cents to euros
 */
var getCustomProductTextValue = function (product, attributeName, customValue) {
    if (customValue) {
        return getProductCustomValueString(product, customValue);
    }
    // support only rendering string and number values
    var propertyPath = attributeName.split('.');
    var productValue = (0, ramda_1.path)(propertyPath, product);
    // make sure that product value is string or number
    if (typeof productValue === 'string' || typeof productValue === 'number') {
        return productValue;
    }
    return '';
};
exports.getCustomProductTextValue = getCustomProductTextValue;
var formatCurrency = function (_a, value) {
    var input = _a.input, output = _a.output;
    // if input format is priceString such as '1.5' or '1.15'
    if (input === seesignage_utils_1.CurrencyInputUnit.priceString && typeof value == 'string') {
        var priceCents = parseFloat(value) * 100;
        if (!isNaN(priceCents)) {
            // valid price
            if (output === seesignage_utils_1.CurrencyOutputUnit.integers) {
                return getEurosString(priceCents);
            }
            else if (output === seesignage_utils_1.CurrencyOutputUnit.decimals) {
                return getDecimalsString(priceCents);
            }
            else if (output === seesignage_utils_1.CurrencyOutputUnit.bothWithComma) {
                return "".concat(getEurosString(priceCents), ",").concat(getDecimalsString(priceCents), " \u20AC");
            }
        }
    }
    // if input format is decimals aka cents
    if (input === seesignage_utils_1.CurrencyInputUnit.decimals &&
        (typeof value == 'string' || typeof value == 'number')) {
        if (output === seesignage_utils_1.CurrencyOutputUnit.integers) {
            return getEurosString(value);
        }
        else if (output === seesignage_utils_1.CurrencyOutputUnit.decimals) {
            return getDecimalsString(value);
        }
        else if (output === seesignage_utils_1.CurrencyOutputUnit.bothWithComma) {
            return "".concat(getEurosString(value), ",").concat(getDecimalsString(value), " \u20AC");
        }
    }
    return value;
};
/**
 * Get formatted string value using provided format options.
 * Used in Text component
 */
var getFormattedStringValue = function (value, format) {
    var _a, _b, _c, _d, _e, _f;
    if (
    // make sure that separator and arrayIndex exits because it might be empty string or null if it has been removed
    ((_a = format.split) === null || _a === void 0 ? void 0 : _a.separator) !== '' &&
        ((_b = format.split) === null || _b === void 0 ? void 0 : _b.separator) !== undefined &&
        ((_c = format.split) === null || _c === void 0 ? void 0 : _c.separator) !== null &&
        ((_d = format.split) === null || _d === void 0 ? void 0 : _d.arrayIndex) !== undefined &&
        ((_e = format.split) === null || _e === void 0 ? void 0 : _e.arrayIndex) !== null &&
        typeof value === 'string') {
        var _g = format.split, separator = _g.separator, arrayIndex = _g.arrayIndex;
        return separator && arrayIndex !== undefined && arrayIndex !== null
            ? value.split(separator)[arrayIndex]
            : value;
    }
    else if ((_f = format.currency) === null || _f === void 0 ? void 0 : _f.output) {
        return formatCurrency(format.currency, value);
    }
    return value;
};
exports.getFormattedStringValue = getFormattedStringValue;
/**
 * Get product attribute value from product object.
 * Note: attribute will be formatted in Text component.
 */
var getProductAttributeValue = function (_a) {
    var product = _a.product, attributeName = _a.attributeName, customValue = _a.customValue, formatOptions = _a.formatOptions;
    if ((0, seesignage_utils_1.isPricerProduct)(product) || (0, seesignage_utils_1.isPlayerOffer)(product)) {
        var value = getCustomProductTextValue(product, attributeName, customValue);
        return formatOptions ? getFormattedStringValue(value, formatOptions) : value;
    }
    else if ((0, seesignage_utils_1.isRetailProduct)(product) ||
        (0, seesignage_utils_1.isGeneralRetailProduct)(product) ||
        (0, seesignage_utils_1.isPharmacyProduct)(product)) {
        var value = getTextValue(product, attributeName, customValue, formatOptions);
        return formatOptions ? getFormattedStringValue(value, formatOptions) : value;
    }
};
exports.getProductAttributeValue = getProductAttributeValue;
var MAX_FONT_SIZE = 600;
/**
 * Get max font size from styles or use defined MAX_FONT_SIZE
 * @param styles
 */
var getMaxFontSizeFromStyles = function (styles) {
    var fontSize = (0, ramda_1.path)(['fontSize'], styles);
    return fontSize ? parseFloat(fontSize) : MAX_FONT_SIZE;
};
var isEmptyObject = function (obj) { return (0, ramda_1.isEmpty)(obj) || Object.values(obj).every(function (x) { return x === null; }); };
/**
 * Get provided textfit-props with possible default values
 * @param textFitProps
 */
var getTextFitProps = function (styles, textFitProps) {
    if (textFitProps && !isEmptyObject(textFitProps)) {
        var mode = textFitProps.mode, max = textFitProps.max, min = textFitProps.min;
        return {
            mode: mode || 'multi',
            max: max || getMaxFontSizeFromStyles(styles),
            min: min,
            style: styles
        };
    }
    return undefined;
};
exports.getTextFitProps = getTextFitProps;
//# sourceMappingURL=values.js.map